import classNames from 'classnames';
import React, { FC, ReactNode, useMemo, useState } from 'react';
import useClient from '~/hooks/useClient';
import Star from '../Star';
import { TabItems } from '../Tabs/Tabs';
import Text from '../Text';
import HowToVerifyWork from './HowToVerifyWork/HowToVerifyWork';
import ImagesReviewSlider from './ImagesReviewSlider';
import TabReviewsItem from './ReviewForItem';
import TabReviewsShop from './ReviewForShop';
import styles from './TabReviews.module.scss';
import ModalWriteReview from './modal-write-review';
import { QUERY_INFO_REVIEWS } from '~/data/home';
import { useQuery } from '@apollo/client';

export interface TabReviewsItems {
    key: string;
    title: string;
    children?: ReactNode;
    total?: number;
}

const tabs: TabItems[] = [
    {
        key: 'reviews-for-this-item',
        title: 'Item reviews',
        children: <TabReviewsItem />
    },
    {
        key: 'reviews-for-this-shop',
        title: 'All reviews',
        children: <TabReviewsShop />
    }
];
type Props = {
    product_rating_summary?: number;
    sku?: string;
};

const TabReviews: FC<Props> = ({ product_rating_summary, sku }) => {
    const [activeTab, setActiveTab] = useState(tabs[0]?.key);
    const { data } = useQuery(QUERY_INFO_REVIEWS, {
        context: { fetchOptions: { method: 'GET' } },
        notifyOnNetworkStatusChange: true
    });

    const summaryAllReview = useMemo(() => {
        return {
            summary: data?.allReview?.summary,
            summary_detail: data?.allReview?.summary_detail,
            total_count: data?.allReview?.total_count
        };
    }, [data]);
    // const [summaryAllReview, setSummaryAllReview] = useState<any>({
    //     summary: 0,
    //     total_count: 0
    // });
    const isClient = useClient();

    const handleTabChange = (value: string) => {
        setActiveTab(value);
    };

    const productSummary = product_rating_summary;
    const summary = (summaryAllReview?.summary * 5) / 100;
    // if (!isClient) return null;

    return (
        <div id="review-tabs" className={classNames('lg:pt-5 flex flex-col gap-4', styles.review_tabs)}>
            <div>
                <ImagesReviewSlider />
                <div className="flex items-center relative j sm:justify-between rounded-md gap-2 sm:gap-5 mt-5 flex-col sm:flex-row bg-slate-100 px-5 py-3">
                    <div className="flex sm:gap-2 items-center flex-col md:flex-row ">
                        <div className={classNames(styles.average_review, 'font-semibold')}>
                            {Number.isNaN(summary) ? 0 : summary}/5
                        </div>
                        <div className="flex gap-1 items-center">
                            <div className="flex gap-[2px] ">
                                <Star value={summary} size={16} />
                            </div>
                            <div className="ml-2">{summaryAllReview?.total_count || 0} Reviews</div>
                        </div>
                    </div>

                    {sku && <ModalWriteReview sku={sku} className="w-full sm:w-[fit-content] mr-2" />}
                    <div className="absolute top-1 right-1">
                        <HowToVerifyWork />
                    </div>
                </div>
            </div>
            <div>
                {!productSummary && (
                    <Text className="font-semibold mb-2" type="body-1">
                        Other reviews from customers
                    </Text>
                )}
                <div className={styles.tabs}>
                    {!productSummary && (
                        <TabReviewsShop
                        //  setSummaryAllReview={setSummaryAllReview}
                        />
                    )}
                    {!!productSummary &&
                        tabs.map((tab) => {
                            const isActive = tab.key === activeTab;
                            return (
                                <div
                                    className={classNames(styles.tab_item, {
                                        [styles.active]: isActive
                                    })}
                                    key={tab.key}
                                    onClick={() => handleTabChange?.(tab.key)}
                                >
                                    <Text
                                        type="body-1"
                                        className={styles.text}
                                    // color={isActive ? Colors.PRIMARY : Colors.GREY_300}
                                    >
                                        {`${tab.title}${tab.total === undefined ? '' : ` (${tab.total})`}`}
                                    </Text>
                                </div>
                            );
                        })}
                </div>

                {!!productSummary && (
                    <div className={styles.tab_content}>
                        {tabs.map((tab) => {
                            return (
                                <div key={tab.key} className={classNames(tab.key === activeTab ? 'block' : 'hidden')}>
                                    {React.cloneElement(tab.children as any, {
                                        // setSummaryAllReview
                                    })}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TabReviews;
